export default __webpack_public_path__ + "static/media/streaks 3.a7561313.svg";